import { Component } from '@angular/core';
import {ActionDTO} from "../../../DTO/PAM/ActionDTO";
import {AxisDTO} from "../../../DTO/PAM/AxisDTO";
import {CommunityDTO} from "../../../DTO/CommunityDTO";
import {ApiService} from "../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {CommunityService} from "../../../services/community/community.service";
import {ThemeService} from "../../../services/theme/theme.service";
import {ODSDTO} from "../../../DTO/PAM/ODSDTO";
import {AreaDTO} from "../../../DTO/PAM/AreaDTO";
import {ConvertSvgComponent} from "../../../components/convert-svg/convert-svg.component";
import {ProgressBarModule} from "primeng/progressbar";
import {MetadataService} from "../../../services/metadata.service";
import {Functions} from "../../../helpers/Functions";

@Component({
  selector: 'app-pam-ods-detail',
  templateUrl: './pam-ods-detail.component.html',
  styleUrl: './pam-ods-detail.component.scss'
})
export class PamOdsDetailComponent {
  ods: ODSDTO;
  actions: ActionDTO[];
  loading = false;
  id:number;
  communityName = "";
  community: CommunityDTO;
  activeIndexActions: number;

  constructor(private apiService: ApiService,
              private actRoute: ActivatedRoute,
              private translate: TranslateService,
              private communityService: CommunityService,
              private themeService: ThemeService,
              private router: Router,
              private metadataService: MetadataService) {
  }
  ngOnInit(): void {
    this.loading = true;
    this.communityName = this.actRoute.snapshot.params['community'];
    this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
    this.communityService.Get().subscribe(res=>{
      this.community = res;
      if (this.community ) {
        this.metadataService.updateMetadata({
          title: Functions.decode( this.community.name) + " - " + this.translate.instant('PAM.titleTab'),
        });
      }
    });
    this.apiService.getOdsDetail(this.communityName , this.id).subscribe((res: ODSDTO) => {
      this.ods = res;
    });
    this.apiService.getActionsByOds(this.communityName , this.id).subscribe((res: ActionDTO[]) => {
      this.actions = res;
      this.loading = false;
    });
  }
  activeIndexChangeActions(index: any) {
    this.activeIndexActions = this.activeIndexActions === index ? -1 : index;
  }
  goDetail(id: number , event: any){
    event.preventDefault();
    event.stopPropagation();
    this.router.navigate([this.communityName+'/PAM/action/' + id ] , {state: {url:'ods/' + this.id}});
  }
  getColorWithOpacity(color: string, opacity: number): string {
    if (color.startsWith('#')) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
    if (color.startsWith('rgb')) {
      return color.replace('rgb', 'rgba').replace(')', `, ${opacity})`);
    }
    return color;
  }
  goBack(): void {
    this.router.navigate([this.communityName+ '/PAM' ] ,{ fragment: 'ods' });
  }

  isTorredembarra(): boolean {
    return (this.community?.code ?? this.communityName)?.toLowerCase() === 'torredembarra';
  }

  actionsLabel(): string {
    return this.isTorredembarra() ? 'Objectius' : this.translate.instant('PAM.actions');
  }

  emptyOdsLabel(): string {
    return this.isTorredembarra() ? "No s'han creat objectius encara amb aquest ODS" : this.translate.instant('PAM.emptyODS');
  }

  noActuationsLabel(): string {
    return this.isTorredembarra() ? 'Aquest objectiu no te actuacions' : 'Aquesta acció no te actuacions';
  }

}

